module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/f58ff42c7adc6e014b696a713af78a79.png";